import { __decorate } from "tslib";
import { Group, Vector3 } from "three";
import { Config } from "../../Config/Config.js";
import { LabelTextConfig } from "../../Config/LabeltextConfig.js";
import { ToolType } from "../../Core/ITool.js";
import { Save, SaveChild } from "../../Core/Save.js";
import { Default } from "../../Utils/Default.js";
import { LimitUtils } from "../../Utils/LimitUtils.js";
import { DraggablePoint } from "../Primitive/DraggablePoint.js";
import { LabelText } from "../Primitive/Label/LabelText.js";
import { LinePointToPoint2 } from "../Primitive/LinePointToPoint2.js";
export class Osteotomy extends Group {
    get length() {
        return this.A.position.distanceTo(this.B.position);
    }
    constructor(viewType, enableLimits) {
        super();
        this.toolType = ToolType.osteotomy;
        this._initialLength = 30;
        this.name = 'Osteotomy';
        this._enableLimits = enableLimits;
        this.add(this.A = new DraggablePoint('A', viewType, Config.osteotomy_colorHex, new Vector3(this._initialLength / 2, 0, 0)), this.B = new DraggablePoint('B', viewType, Config.osteotomy_colorHex, new Vector3(this._initialLength / -2, 0, 0)), this.C = new DraggablePoint('C', viewType, Config.osteotomy_colorHex, this.A.position.clone().lerp(this.B.position, 0.5)), this.ABLine = new LinePointToPoint2('ABLine', viewType, Config.osteotomy_colorHex, this.A, this.B), this.label = new LabelText({
            name: 'label',
            color: LabelTextConfig.color, //todo refactor
            viewType,
            objToAnchor: this.C,
            anchor: new Vector3(0, 5, 0),
            labelParams: { text: 'Osteotomy', backgroundColor: Config.osteotomy_colorCssAlpha, fontColor: Config.osteotomy_fontColor, borderColor: Config.osteotomy_colorCss }
        }));
        this.bindEvents();
    }
    bindEvents() {
        Default.bindOnEnabledChange_NoRaycastAndHiddenLabel(this);
        this.addEventListener('historyChanged', () => {
            this.dispatchEvent({ type: 'updated' });
        });
        this.A.bindEvent('onDragMove', (args) => {
            this._enableLimits && LimitUtils.applyMultiLimits(args.position, this.A.position, [
                { a: this._axisPoint1, b: this._axisPoint1.clone().add(this._axisPerp), v: this._axisValidPoint },
                { a: this._axisPoint2, b: this._axisPoint2.clone().add(this._axisPerp), v: this._axisValidPoint }
            ]);
            this.C.position.copy(args.position.clone().lerp(this.B.position, 0.5));
        });
        this.B.bindEvent('onDragMove', (args) => {
            this._enableLimits && LimitUtils.applyMultiLimits(args.position, this.A.position, [
                { a: this._axisPoint1, b: this._axisPoint1.clone().add(this._axisPerp), v: this._axisValidPoint },
                { a: this._axisPoint2, b: this._axisPoint2.clone().add(this._axisPerp), v: this._axisValidPoint }
            ]);
            this.C.position.copy(args.position.clone().lerp(this.A.position, 0.5));
        });
        this.C.bindEvent('onDragMove', (args) => {
            this._enableLimits && LimitUtils.applyLimitAndProjectVectorCenterLinePoint(this._axisPoint1, this._axisPoint1.clone().add(this._axisPerp), this.C.position, args.position, this.A.position, this.B.position, this._axisValidPoint);
            this._enableLimits && LimitUtils.applyLimitAndProjectVectorCenterLinePoint(this._axisPoint2, this._axisPoint2.clone().add(this._axisPerp), this.C.position, args.position, this.A.position, this.B.position, this._axisValidPoint);
            this.translateAB(args.position);
        });
    }
    updateCenter(newCenter) {
        this.translateAB(newCenter);
        this.C.position.copy(newCenter);
    }
    updateCenterAndOsteotomyStartPoints(newCenter) {
        this.updateCenter(newCenter);
        this.startingA = this.A.position.clone(); //todo put in mech
        this.startingB = this.B.position.clone();
    }
    translateAB(newCenter) {
        const pan = this.C.position.clone().sub(newCenter);
        this.A.position.sub(pan);
        this.B.position.sub(pan);
    }
    placeOsteotomyByApex(origin, direction) {
        const dir = direction.clone().setLength(this._initialLength / 2);
        this.C.position.copy(origin);
        this.A.position.copy(origin).add(dir);
        this.B.position.copy(origin).sub(dir);
        this.startingA = this.A.position.clone();
        this.startingB = this.B.position.clone();
    }
}
__decorate([
    Save('position')
], Osteotomy.prototype, "A", void 0);
__decorate([
    Save('position')
], Osteotomy.prototype, "B", void 0);
__decorate([
    Save('position')
], Osteotomy.prototype, "C", void 0);
__decorate([
    SaveChild()
], Osteotomy.prototype, "label", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "startingA", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "startingB", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "selectedApex", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "_axisPoint1", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "_axisPoint2", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "_axisPerp", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "_axisDir", void 0);
__decorate([
    Save()
], Osteotomy.prototype, "_axisValidPoint", void 0);
//# sourceMappingURL=Osteotomy.js.map